import React from "react";

const formatWhatsAppText = (text, samples = {}) => {
  if (!text) return "";
  let formatted = text
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
    
  // Replace variables {{1}}, {{2}} with sample values
  formatted = formatted.replace(/{{(\d+)}}/g, (match, num) => {
    const key = `{{${num}}}`;
    // Use the sample value if it exists and is not empty, otherwise keep the placeholder
    return (samples[key] && samples[key].trim() !== "") ? samples[key] : match;
  });

  formatted = formatted
    // Replace ```monospace```
    .replace(/```([\s\S]*?)```/g, '<code style="font-family: monospace; background: rgba(0,0,0,0.05); padding: 2px 4px; border-radius: 4px;">$1</code>')
    // Replace *bold*
    .replace(/\*([^\*]+)\*/g, '<strong>$1</strong>')
    // Replace _italic_
    .replace(/_([^_]+)_/g, '<em>$1</em>')
    // Replace ~strikethrough~
    .replace(/~([^~]+)~/g, '<del>$1</del>');
    
  return formatted;
};

export default function WhatsAppPreview({
  templateName = "template_name",
  headerType = "NONE",
  headerText = "",
  headerPreview = null,
  bodyText = "",
  footerText = "",
  buttons = [],
  samples = {},
}) {
  return (
    <div
      style={{
        width: "240px",
        height: "420px",
        backgroundColor: "#000",
        borderRadius: "28px",
        padding: "3px",
        boxShadow: "0 8px 30px rgba(0,0,0,0.3)",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "#e5ddd5",
          borderRadius: "25px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* STATUS BAR */}
        <div
          style={{
            height: "32px",
            backgroundColor: "#075e54",
            color: "white",
            fontSize: "12px",
            padding: "0 12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>9:41</span>
          <span>📶 📶 🔋</span>
        </div>

        {/* CHAT HEADER */}
        <div
          style={{
            backgroundColor: "#075e54",
            padding: "6px 12px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <div
            style={{
              width: "28px",
              height: "28px",
              backgroundColor: "#facc15",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
            A
          </div>
          <div>
            <div style={{ fontSize: "13px", color: "#fff" }}>account</div>
            <div style={{ fontSize: "10px", color: "#d1fae5" }}>online</div>
          </div>
        </div>

        {/* CHAT AREA */}
        <div style={{ flex: 1, padding: "10px" }}>
          <div
            style={{
              backgroundColor: "#dcf8c6",
              borderRadius: "6px",
              padding: "8px",
              maxWidth: "85%",
              marginLeft: "auto",
            }}
          >
            {/* TEMPLATE NAME */}
            <div style={{ fontSize: "9px", color: "#555", marginBottom: "4px" }}>
              {templateName}
            </div>

            {/* HEADER */}
            {headerType === "TEXT" && headerText && (
              <div style={{ fontWeight: "600", marginBottom: "6px" }}>
                {headerText}
              </div>
            )}

             {headerType === "IMAGE" && headerPreview && (
            <img
              src={headerPreview}
              alt="preview"
              className="w-full rounded mb-2"
            />
          )}

          {/* VIDEO */}
          {headerType === "VIDEO" && headerPreview && (
            <video
              src={headerPreview}
              controls
              className="w-full rounded mb-2"
            />
          )}

          {/* DOCUMENT */}
          {headerType === "DOCUMENT" && (
            <div className="flex items-center gap-2 bg-gray-100 p-2 rounded mb-2 text-xs">
              📄 Document attached
            </div>
          )}

            {/* BODY */}
            <div
              style={{
                fontSize: "12px",
                lineHeight: "1.4",
                whiteSpace: "pre-wrap",
              }}
              dangerouslySetInnerHTML={{
                __html: bodyText ? formatWhatsAppText(bodyText, samples) : "Your message content will appear here"
              }}
            />

            {/* FOOTER */}
            {footerText && (
              <div
                style={{
                  fontSize: "10px",
                  color: "#666",
                  marginTop: "6px",
                }}
              >
                {footerText}
              </div>
            )}

            {/* BUTTONS */}
            {buttons.length > 0 && (
              <div style={{ marginTop: "8px" }}>
                {buttons.map((btn, i) => (
                  <div
                    key={i}
                    style={{
                      background: "#fff",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      padding: "6px",
                      marginTop: "6px",
                      fontSize: "11px",
                      color: "#0b5cff",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                  >
                    {btn.text || "Button"}
                  </div>
                ))}
              </div>
            )}

            {/* TIME */}
            <div
              style={{
                fontSize: "9px",
                color: "#666",
                textAlign: "right",
                marginTop: "4px",
              }}
            >
              10:51 AM ✓✓
            </div>
          </div>
        </div>

        {/* INPUT */}
        <div style={{ padding: "8px", background: "#f0f0f0" }}>
          <div
            style={{
              background: "#fff",
              borderRadius: "16px",
              padding: "6px 10px",
              fontSize: "11px",
              color: "#999",
            }}
          >
            Type a message…
          </div>
        </div>
      </div>
    </div>
  );
}
